import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import AttendanceAndTimeTableSettings from "Administrator/routes/AttendanceAndTimetableSettings";
import AttendanceSettingsV2 from "Administrator/routes/AttendanceSettingsV2";

export default store => ({
  path: "school-operations",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "school-operations" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [
    AttendanceAndTimeTableSettings(store),
    AttendanceSettingsV2(store),
  ],
});
